import { useState, useEffect, useContext } from "react";
import transactionServices from "../../../../services/transactionServices";
import { useSnackbar } from "notistack";
import RejectTransaction from "../../../../components/modals/RejectTransaction";
import PaymentMode from "../../../../components/modals/paymentMode";
import UPIPaymentModal from "../../../../components/modals/upiPaymentModal";
import ConfirmaTransaction from "../../../../components/modals/confirmTransaction";
import CompletePaymentModal from "./completePayment";
import { Stack, Card, Typography, Divider, ToggleButtonGroup, ToggleButton, CardContent, Button, Box } from "@mui/material";
import { InvestFormContext } from "./contexts/InvestFormContext";
import { InvestCalculationContext } from "./contexts/InvestCalculationContext";
import { InvestAccountContext } from "./contexts/InvestAccountContext";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { InvestPaymentContext } from "./contexts/InvestPaymentContext";
import { NoteComponent } from "./noteComponent";
import { useNavigate } from "react-router-dom";
import { PaymentDetails } from "./paymentDetails";
import logsService from "../../../../services/logServices";
import InvestorActivityEventType from "../../../../utils/eventTypes";

export const PaymentInformation = () => {
    const [paymentModal, setPaymentModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [rejectModal, setRejectModal] = useState(false);
    const [paymentModeModal, setPaymentModeModal] = useState(false);
    const [upiModal, setUpiModal] = useState(false);
    const [reqData, setReqData] = useState();
    const [reqData2, setReqData2] = useState();
    const [loading, setLoading] = useState(false);
    const [upiTransactionId, setUpiTransactionId] = useState(null);
    const [upiTransactionExpiryTime, setUpiTransactionExpiryTime] = useState(null);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { coupon, amount, amountAfterDiscount, referedBy, beneficiaryInfo, getFilteredBeneficiaries, assetTermsId } = useContext(InvestFormContext);
    const { couponCashback, discRPF, costFrax, NoFrax, setNoFrax, selectDiscount, crossedAmount, setCrossedAmount } = useContext(InvestCalculationContext);
    const { availableBlockchainAccounts, selectedBlockchainAccountIndex, accountSelected, familyMembers, entityId } = useContext(InvestAccountContext);
    const { activeStep, selectedMode, listing, user, transaction, getPrevInvestments, resetInvestPage, commitmentDate } = useContext(InvestTransactionContext);
    const { amtPaid, pendingAmt, setPendingAmt, setAmttoBePaid, amtTobePaid, isFullPayment, setIsFullPayment, isFullPaymentEditable, disablecheckbox } = useContext(InvestPaymentContext);

    // Update the reqData object to use filtered beneficiaries
    useEffect(() => {
        if (listing && user) {
            let temp = {
                rightToOwnerShip: selectedMode === 1,
                amount: amount,
                rpf: discRPF || costFrax,
                pendingAmt: pendingAmt,
                amtTobePaid: amtTobePaid,
                termsAndConditionsId: assetTermsId,
                beneficiaries: getFilteredBeneficiaries(),
                noOfFracs: NoFrax,
                listingId: listing._id,
                projectId: listing.projectId,
                developerId: listing.developerId,
                assetClass: listing.assetClass,
                user_id: user._id,
                accountSelected: accountSelected,
                entityType: accountSelected === "HUF" ? "HUF" : accountSelected === "Trust" ? "TRUST" : accountSelected === "Personal" ? "PERSONAL" : "FAMILYMEMBER",
                entityId: entityId,
                ...((accountSelected !== "Personal" && accountSelected !== "HUF" && accountSelected !== "Trust") && { username: familyMembers.find(member => member.username === accountSelected)?.username }),
                dltAccount: availableBlockchainAccounts[selectedBlockchainAccountIndex || 0]?.publicAddress,
                dltNickname: availableBlockchainAccounts[selectedBlockchainAccountIndex || 0]?.name,
                network: availableBlockchainAccounts[selectedBlockchainAccountIndex || 0]?.network.toUpperCase(),
                couponCashback,
                discounts: {
                    select: +selectDiscount
                },
                coupon: localStorage.getItem("coupon") || "",
                referedBy
            }

            if (transaction) {
                let temp2 = {
                    transactionId: transaction._id
                }
                setReqData2(temp2)
            }
            setReqData(temp);
        }
        // eslint-disable-next-line
    }, [selectedMode, amount, beneficiaryInfo, NoFrax, listing, selectDiscount, coupon, couponCashback, isFullPayment, selectedBlockchainAccountIndex, accountSelected, availableBlockchainAccounts, assetTermsId]);

    const handleCompletePayment = () => {
        setPaymentModeModal(true);
        // handleBankTransfer();
    }

    const handleBankTransfer = () => {
        setPaymentModeModal(false);
        setPaymentModal(true);
    }

    const handleFullPayment = async (event, newValue) => {
        const isChecked = newValue;

        setIsFullPayment(isChecked);
        if (isChecked) {
            const temp = amtTobePaid + pendingAmt;
            setAmttoBePaid(temp);
            setPendingAmt(0);
        } else {
            const frax = amount / (discRPF || costFrax);
            let roundedUpAmount = Math.ceil(frax * (discRPF || costFrax));
            if (selectDiscount) {
                roundedUpAmount = roundedUpAmount - selectDiscount;
            }
            if (roundedUpAmount >= 205000) {
                // const amount = amtTobePaid;
                const oldAmountToBePaid = Math.round(200000 + (roundedUpAmount - 200000) / 10);
                setAmttoBePaid(oldAmountToBePaid);
                setPendingAmt(roundedUpAmount - oldAmountToBePaid);
            }
        }
    }

    const handleWalletPay = async (walletPayAmount) => {
        let tempReqData = {};
        if (walletPayAmount < amtTobePaid) {
            tempReqData = { ...reqData, amtTobePaid: walletPayAmount, isFullPayment: false };
            setReqData(tempReqData);
        }
        else {
            tempReqData = { ...reqData, isFullPayment };
            setReqData(tempReqData);
        }
        setLoading(true);
        setPaymentModeModal(false);
        const res = await transactionServices.createTransaction({ ...tempReqData, paymentMethod: "WALLET" });
        if (res && res.success) {
            enqueueSnackbar("Payment successful.", { variant: "success", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
            navigate("/transactions")
            logsService.addLog({
                userId: user?._id,
                event: InvestorActivityEventType.WALLET_PAYMENT_SUCCESSFUL,
                listingId: listing?._id
            })
        }
        else {
            enqueueSnackbar(res?.data?.message || res?.message || "Something went wrong", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
        }
        setLoading(false);
    }

    const onUPI = async () => {
        try {
            setLoading(true);
            setPaymentModeModal(false);
            const initiated = await handleUPIInitiate();
            if (initiated) setUpiModal(true);
        } catch (error) {
            enqueueSnackbar("Unable to proceed with UPI currently, Please try again after some time!", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
        } finally {
            setLoading(false);
        }
    }

    const handleUPIInitiate = async () => {
        try {
            setUpiModal(false);
            setUpiTransactionId(null);
            setUpiTransactionExpiryTime(null);
            const res = await transactionServices.createTransaction({ ...reqData, paymentMethod: "UPI" });
            if (res && res.success) {
                setUpiTransactionId(res.data.transactionId);
                setUpiTransactionExpiryTime(res.data.expiryDate);
                // TODO: add event of UPI here
                return true;
            }
            else enqueueSnackbar(res?.data?.message || res?.message || "Unable to Initiate UPI currently", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
        } catch (error) {
            enqueueSnackbar("Something went wrong", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
        }
        return false;
    }

    const handleUPISubmit = async () => {
        try {
            const res = await transactionServices.confirmUPIRequest({ transactionId: upiTransactionId });
            if (res && res.success) {
                enqueueSnackbar("Payment Request Submitted.", { variant: "success", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
                navigate("/transactions")
            } else {
                enqueueSnackbar(res?.data?.message || res?.message || "Transaction Expired!", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
                resetInvestPage();
            }
        } catch (error) {
            enqueueSnackbar("Something went wrong", { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
        }
    }

    const handlePayementGateway = async () => {
        setPaymentModeModal(false);
        const res = await transactionServices.createOrder({ ...reqData, paymentMethod: "RZ" });
        // console.log(res);
        if (res && res.success) {
            const order = res.data;
            const options = {
                key: order.notes.key,
                amount: order.amount,
                currency: "INR",
                name: user.name,
                description: "Purchase Frax",
                order_id: order.id,
                // callback_url: `https://pupperazy-backend.odinflux.com/transaction/verifyOrder/${order.notes.transactionId}`,
                // callback_url: `http://192.168.0.114:5000/transaction/verifyOrder/${order.notes.transactionId}`,
                // callback_url: `http://192.168.0.109:80/transaction/verifyOrder/${order.notes.transactionId}`,
                // callback_url: `${process.env.REACT_APP_API_URL}transaction/verifyOrder/${order.notes.transactionId}`,
                // callback_url: `https://api.pupperazy.com/transaction/verifyOrder/${order.notes.transactionId}`,
                handler: (res) => {
                    // console.log(res,"test");
                    enqueueSnackbar("Payment successfull.", { variant: "success", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
                    navigate("/transactions")
                    logsService.addLog({
                        userId: user?._id,
                        event: InvestorActivityEventType.PAYMENT_SUCCESSFUL,
                        listingId: listing?._id
                    })
                },
                prefill: {
                    name: user.name,
                    email: user.email,
                    contact: user.number
                },
                notes: {
                    "address": "REALX"
                },
                theme: {
                    "color": "#2F6BF2"
                },
                modal: {
                    escape: false,
                    confirm_close: true,
                    ondismiss: () => {
                        // console.log("fkdhf")
                    }
                }
            };
            const razor = new window.Razorpay(options);
            razor.on('payment.failed', function (response) {
                // console.log(response.error.code);
                // console.log(response.error.description);
                // console.log(response.error.source);
                // console.log(response.error.step);
                // console.log(response.error.reason);
                // console.log(response.error.metadata.order_id);
                // console.log(response.error.metadata.payment_id);
            });
            razor.open();
        }
        else {
            enqueueSnackbar(res.data.message, { variant: "error", anchorOrigin: { horizontal: "center", vertical: "bottom" }, autoHideDuration: 2000 })
        }
    }
    const entityType = accountSelected === "HUF" ? "HUF" : accountSelected === "Trust" ? "TRUST" : accountSelected === "Personal" ? "PERSONAL" : "FAMILYMEMBER"
    return (
        <Stack direction={"column"} spacing={2}>
            {paymentModal && <CompletePaymentModal open={paymentModal} handleClose={() => setPaymentModal(false)} paymentDetails={<PaymentDetails inModal={true} />} isFullPayment={isFullPayment} data={reqData} getTransaction={getPrevInvestments} />}
            {/* below we do  amount={amtTobePaid || amount} as for first time when user is making vert first payment , we need to send whole amount but later we need to send amount he has to now pay or pending amount one and the same*/}
            {confirmModal && <ConfirmaTransaction open={confirmModal} handleClose={() => setConfirmModal(false)} amtPaid={amtPaid} data={reqData2} amount={amountAfterDiscount} pendingAmt={pendingAmt} amtTobePaid={amtTobePaid} commitmentDate={commitmentDate} entityId={entityType === "FAMILYMEMBER" ? user._id : (entityId || user._id)} entityType={entityType} tokenName={listing?.assetClass?.tokenName} listingId={listing?._id} />}
            <RejectTransaction open={rejectModal} handleClose={() => setRejectModal(false)} data={reqData2} amount={amount} pendingAmt={pendingAmt} amtTobePaid={amtTobePaid} userId={user?._id} listingId={listing?._id} />
            {paymentModeModal && <PaymentMode
                open={paymentModeModal}
                handleClose={() => setPaymentModeModal(false)}
                isUPIEnabled={true}
                onUPI={onUPI}
                onBankTransfer={handleBankTransfer}
                onPaymentGateway={handlePayementGateway}
                onWalletPay={handleWalletPay}
                walletPayAmount={amtTobePaid}
                loading={loading}
            />}
            {upiModal && <UPIPaymentModal
                open={upiModal}
                handleClose={() => setUpiModal(false)}
                onExpiredClose={resetInvestPage}
                onSubmit={handleUPISubmit}
                expiryTime={upiTransactionExpiryTime}
                transactionRef={upiTransactionId}
                amount={amtTobePaid}
            />}
            <Stack direction={"column"} spacing={2} sx={{
                display: {
                    md: "block",
                    xs: activeStep > 2 ? "block" : "none",
                }
            }}>
                <Card sx={{ borderRadius: "10px" }}>
                    <CardContent>
                        <Typography variant="body3" sx={{ fontWeight: 500 }}>Payment Information</Typography>
                        <Divider sx={{
                            width: "calc(100% + 80px)",
                            margin: '15px -40px 24px'
                        }} />
                        <PaymentDetails />
                    </CardContent>
                </Card>
            </Stack>

            <Card>
                <CardContent>
                    <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} mt={2}>
                        {/* <FormLabel id="toggle-buttons-group-label"  sx={{ lineHeight: 1 }}> */}
                        <Typography variant="body3">Select payment option</Typography>
                        {/* </FormLabel> */}
                        <ToggleButtonGroup value={isFullPayment} exclusive onChange={handleFullPayment} disabled={disablecheckbox || !isFullPaymentEditable} sx={{ cursor: disablecheckbox === true ? "not-allowed" : "pointer" }}>
                            <ToggleButton value={true} aria-label="Full payment" sx={{ border: '1px solid black', padding: "8px 20px", bgcolor: isFullPayment === true ? "#ff382d !important" : "", color: isFullPayment === true ? "#FFF !important" : "gray" }}>
                                Full payment
                            </ToggleButton>
                            <ToggleButton value={false} aria-label="Partial payment" sx={{ cursor: disablecheckbox === true ? "not-allowed" : "pointer", border: '1px solid black', padding: "8px 20px", bgcolor: isFullPayment === false ? "#ff382d !important" : "", color: isFullPayment === false ? "#FFF !important" : "" }}>
                                Partial payment
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Stack>
                </CardContent>
            </Card>

            <Stack spacing={2}>
                {
                    transaction ?
                        <>
                            {
                                transaction?.status == "PARTPAID" &&
                                <Stack direction="row" alignItems="center" gap="10px">
                                    <Button disabled={transaction?.newpaymentMade} variant="contained" color="secondary" onClick={() => setConfirmModal(true)}
                                        sx={{ width: "100%" }}
                                    >
                                        Make Additional Payment
                                    </Button>
                                    {/* <Button sx={{ width: "50%",padding:'19px 24px !important'}} onClick={() => { setRejectModal(true); }} variant="outlined" >Cancel</Button> */}
                                </Stack>
                            }
                            {
                                transaction?.status == "CREATED" &&
                                <Stack direction="row" alignItems="center" gap="10px">
                                    <Button variant="contained" color="secondary" onClick={() => setConfirmModal(true)}
                                        sx={{ width: "50%" }}
                                    >
                                        Confirm
                                    </Button>
                                    <Button sx={{ width: "50%", padding: '16px 22px !important' }} onClick={() => { setRejectModal(true); }} variant="outlined" >Cancel</Button>
                                </Stack>
                            }
                        </>
                        :
                        <>
                            <Button fullWidth disabled={activeStep !== 5} variant="contained" color="secondary" onClick={handleCompletePayment}>
                                Complete Payment
                            </Button>
                            <NoteComponent />
                        </>
                }
            </Stack>

            {/* <Box sx={{
                position: "fixed",
                width: "100%",
                bottom: 0,
                left: 0,
                bgcolor: "white",
                borderRadius: "15px 15px 0px 0px",
                boxShadow: "0px 3px 10px #00000066",
                padding: "16px 24px",
                display: { md: "none", xs: "block" }
            }}>
                <Stack spacing={2}>
                    {
                        transaction ?
                            <>
                                <Stack direction="row" alignItems="center" gap="10px">
                                    <Button variant="contained" color="secondary" onClick={() => setConfirmModal(true)}
                                        sx={{ width: "50%" }}
                                    >
                                        Confirm
                                    </Button>
                                    <Button sx={{ width: "50%", padding: '16px 24px !important' }} onClick={() => { setRejectModal(true); }} variant="outlined">Cancel</Button>
                                </Stack>
                            </>
                            :
                            <>
                                <Button fullWidth disabled={activeStep !== 5} variant="contained" color="secondary" onClick={handleCompletePayment}>
                                    Complete Payment
                                </Button>
                                <NoteComponent />
                            </>
                    }
                </Stack>
            </Box> */}
        </Stack>
    );
}